import { ReactNode } from "react";
import { SearchProvider } from "shared/contexts/SearchContext";
import { GeneralProvider } from "shared/contexts/GeneralContext";
import { FilterProvider } from "shared/contexts/FilterContext";

// Tip: se for usar fontes, use @fontsource ou import <link> no index.html

type LayoutProps = {
  children: ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
  //   script.async = true;
  //   document.body.appendChild(script);
  // }, []);

  return (
    <div>
      <GeneralProvider>
        <SearchProvider>
          <FilterProvider>{children}</FilterProvider>
        </SearchProvider>
      </GeneralProvider>
    </div>
  );
}
